<template>
  <div class="banner q-mt-md q-mb-md">
    <q-banner rounded class="text-white" :class="bgClass">
      <slot></slot>
    </q-banner>
  </div>
</template>
<script>
export default {
  name: "Banner",
  props: {
    mode: {
      type: String,
      required: true,
      validator(value) {
        return ["positive", "negative", "info"].includes(value);
      },
    },
  },
  computed: {
    bgClass() {
      return `bg-${this.mode}`;
    },
  },
};
</script>
<style lang="scss" scoped></style>
